<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :label="$t('SeaExport.batchImportCharge')" name="batchImportChargeAllBusiness" :lazy="true">
              <batch-import-charge-all-business ref="batchImportChargeAllBusiness" :lob="lob" />
            </el-tab-pane>
            <el-tab-pane :label="$t('SeaExport.historyLogQuery')" name="importAllBusinessRecordSearch" :lazy="true">
              <import-all-business-record-search ref="importAllBusinessRecordSearch" :lob="lob" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BatchImportChargeAllBusiness from '@/views/cargo/v0/Clearing/ImportChargeAllBusiness/importCharge/batchImportChargeAllBusiness.vue'
import ImportAllBusinessRecordSearch from '@/views/cargo/v0/Clearing/ImportChargeAllBusiness/importCharge/importAllBusinessRecordSearch.vue'

export default {
  name: 'ImportChargeAllBusinessTab',
  components: { ImportAllBusinessRecordSearch, BatchImportChargeAllBusiness },
  props: {
    lob: { type: String, required: true } // 业务类型
  },
  data() {
    return {
      activeTabName: 'batchImportChargeAllBusiness'
    }
  },
  created() {
    this.handleClick()
  },
  methods: {
    // tab 页签点击事件
    handleClick() {
      this.$nextTick(() => {
        this.$refs[this.activeTabName].onShow()
      })
    }
  }
}
</script>

<style scoped>

</style>
